import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Metadata, State } from "../state/types";
import { upsertDraft, upsertDraftFailure, upsertDraftSuccess } from "./animals";

export const metadataSlice = createSlice({
  name: "metadata",
  initialState: {} as State["metadata"],
  reducers: {
    updateMetadata: (metadata, action: PayloadAction<Partial<Metadata>>) => {
      return {
        ...metadata,
        ...action.payload,
      };
    },
    updateApplyPreventiveAddonToAll: (
      metadata,
      action: PayloadAction<{ active: boolean; limit: number }>
    ) => {
      metadata.applyPreventiveCareToAll = action.payload.active;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(upsertDraft, (state, _action) => {
      state.loading = true;
      state.error = null;
    });

    builder.addCase(upsertDraftSuccess, (state, action) => {
      state.draftId = action.payload.draftId;
      state.loading = false;
      state.error = null;
    });

    builder.addCase(
      upsertDraftFailure,
      (state, action: PayloadAction<Error>) => {
        state.loading = false;
        state.error = action.payload;
      }
    );
  },
});

export const { updateMetadata, updateApplyPreventiveAddonToAll } =
  metadataSlice.actions;

export const metadataReducer = metadataSlice.reducer;
